/*
 *
 * Modals constants
 *
 */

export const OPEN_MODAL = 'app/Modals/OPEN_MODAL';
export const CLOSE_MODAL = 'app/Modals/CLOSE_MODAL';
